import * as React from 'react'
import * as classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faTriangleExclamation,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons'

import * as Style from './style.css'

export interface IProps {
  title?: string
  children: React.ReactNode
  color?: 'warning' | 'notice'
}

export const InformationText = ({
  title,
  children,
  color,
}: IProps): JSX.Element => {
  const statusClass = {
    [Style.InformationText]: true,
    [Style.InformationTextWarning]: color === 'warning',
    [Style.InformationTextNotice]: color === 'notice',
  }

  return (
    <div className={classNames(statusClass)}>
      {color === 'warning' && (
        <>
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            className={Style.InformationTextIconWarning}
          />
          <span className={Style.InformationTextTitleWarning}>{title}</span>
        </>
      )}
      {color === 'notice' && (
        <>
          <FontAwesomeIcon
            icon={faCircleExclamation}
            className={Style.InformationTextIconNotice}
          />
          <span className={Style.InformationTextTitleNotice}>{title}</span>
        </>
      )}
      <div className={Style.InformationTextBody}>{children}</div>
    </div>
  )
}

export default InformationText
